import type { ElPeriodo } from '@/lib/supabase/tipos-bd'
import { horas, pesos } from '@/shared/utilidades/formato'

import estilos from './CifrasDelPeriodo.module.css'

/**
 * La productividad, por persona: los servicios suyos que se finalizaron esa
 * semana y lo que valen. Ordenado por valor. Una barra en cada fila para comparar sin leer
 * números; el número exacto, al lado.
 */
export function PorTecnico({ filas }: { filas: ElPeriodo['por_tecnico'] }) {
  if (filas.length === 0) {
    return <p className={estilos.vacio}>No se finalizó ningún servicio en este periodo.</p>
  }

  const maximo = Math.max(1, ...filas.map((f) => Number(f.valor)))

  return (
    <div className={estilos.tablaCaja}>
      <table className={estilos.tabla}>
        <thead>
          <tr>
            <th>Técnico</th>
            <th className={estilos.num}>Finalizados</th>
            <th className={`${estilos.num} ${estilos.sinHorasEnCelular}`}>Horas</th>
            <th className={estilos.num}>Valor</th>
          </tr>
        </thead>
        <tbody>
          {filas.map((f) => (
            <tr key={f.nombre}>
              <td>
                <span className={estilos.nombre}>
                  {/* Nombre y primer apellido: hay dos «Juan Diego». */}
                  {f.nombre.split(' ').slice(0, 3).join(' ')}
                </span>
                <span className={estilos.barraFila}>
                  <span style={{ width: `${(Number(f.valor) / maximo) * 100}%` }} />
                </span>
              </td>
              <td className={estilos.num}>{f.finalizados}</td>
              <td className={`${estilos.num} ${estilos.sinHorasEnCelular}`}>
                {horas(Number(f.horas))}
              </td>
              <td className={estilos.num}>{pesos(Number(f.valor))}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
